import React, { useState, useEffect } from 'react';
import { SingleInput } from '../../Res/BaseInput';
import { ContentBox } from '../ContentBox';
import { ReqRecruitmentContractorCaseInfo, VIEW_CASESTATUS1, CASE_STATUS_ONBOARD } from '../../../../item/ItemRecruitmentContractor';
import { CancelSubmitButton } from '../../Res/BaseButton';
import moment from 'moment';
import { getOnlyDate } from '../../../../item/ItemTools';
import { toRevise } from './ReviseSOPTools';

/**
 * 逾期報到作業
 * @param {*} param0 
 */
export function ReviseOverdue({ item, action, vw_status, setIsLoading }) {
    const [mItem, setItem] = useState({})

    const [caseComment, setCaseComment] = useState("")
    const [caseOnBoardDate, setCaseOnBoardDate] = useState('')

    const description = "進行 “逾期報到作業”"

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            // console.log(item)
            setItem(item)
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            // console.log(mReqRecruitmentContractorCaseInfo)
            setCaseOnBoardDate(moment(mReqRecruitmentContractorCaseInfo.caseReserveDate).format('YYYY-MM-DD'))
        }
    }, [item])

    function toCancel() {
        action(VIEW_CASESTATUS1)
    }

    function toAction() {
        toRevise(mItem, "逾期報到作業已完成", {
            setIsLoading,
            description: getOnlyDate() + " 逾期報到作業",
            comment: caseComment,
            caseOnBoardDate,
            caseStatus: CASE_STATUS_ONBOARD
        })
    }

    var superTitle = description
    var title = ""
    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    {vw_status}
                    <div className="col-md-3">
                        <p className="col-md-12">
                            將會以”預定上工日“作為”實際上工日“</p>
                        <p className="col-md-12">
                            “上工日期”如不對，先校正“預定上工日”</p>
                    </div>
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleInput title={"本次作業的評論/備註"} val={caseComment} action={setCaseComment} placeholder={"請儘量簡短"} size={6} />
                </div>
            </div>
        </>

    var footer =
        <div className="row text-right ">
            <div className="col-sm-12">
                <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAction} isRight={true} />
            </div>
        </div>

    return (
        <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    )
}